import { parse } from 'query-string'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as DomainActions from '../domain-deliverability/actions'
import * as Actions from './actions'
import * as Constants from './constants'

const initialLoad = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_ENGAGEMENT_SUMMARY_URL))
  .map(() => parse(history.location.search))
  .map((searchParams) =>
    Actions.fetchEngagementSummary(
      store.getState().app.selectedCommunity,
      searchParams.sinceDate))

const switchCommunity = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(IsActive.filterStatusConstant(Constants.CHANGE_COMMUNITY))
  .map((action: IsActive.FilterActionObject) =>
   DomainActions.fetchDomainEngagementSummary(action.filter.value,
                                              store.getState().engagementSummary.view.selectedTime.value),
  )

const switchDomainTimespan = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(IsActive.filterStatusConstant(Constants.CHANGE_TIME_SPAN))
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_DELIVERABILITY_SUMMARY_URL))
  .mergeMap((action: IsActive.FilterActionObject) => [
    App.updateUrlParams({sinceDate: action.filter.value}),
    DomainActions.fetchDomainEngagementSummary(
      store.getState().engagementSummary.view.selectedCommunity.value,
      action.filter.value),
  ])

const switchEngagementTimespan = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(IsActive.filterStatusConstant(Constants.CHANGE_TIME_SPAN))
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_ENGAGEMENT_SUMMARY_URL))
  .mergeMap((action: IsActive.FilterActionObject) => [
    App.updateUrlParams({sinceDate: action.filter.value}),
    Actions.fetchEngagementSummary(
      store.getState().engagementSummary.view.selectedCommunity.value,
      action.filter.value),
  ])

export const epic = ReduxObservable.combineEpics(
  initialLoad,
  switchCommunity,
  switchEngagementTimespan,
  switchDomainTimespan,
)



// WEBPACK FOOTER //
// ./src/pages/engagement-summary/epic.ts